import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Catch-all redirect for legacy / mistyped top-level paths.
 *
 * Older notifications (and already-sent emails) stored links like
 * `/claims/:id`, `/finance-ic/invoices/:id` or `/profit-share/adjustments/:id`.
 * The app only mounts `/tutor/*` and `/admin/*` (see App.js), so those paths
 * matched no route and rendered a blank white page. This component maps those
 * legacy paths onto the real dashboard route for the logged-in user's role.
 *
 * Role convention matches PrivateRoute: admin/finance -> /admin, else -> /tutor.
 */
const LegacyLinkRedirect = () => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  // Not logged in -> send to login.
  if (!token) {
    return <Navigate to="/" replace />;
  }

  let role = 'tutor';
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    role = user.role || 'tutor';
  } catch (e) {
    // Corrupt user data -> treat as tutor; PrivateRoute will handle auth issues.
  }

  const isAdmin = role === 'admin' || role === 'finance';
  const path = location.pathname;

  // Map known legacy top-level paths to real routes.
  const target = (() => {
    if (path.startsWith('/claims')) {
      return isAdmin ? '/admin/claims' : '/tutor/claims';
    }
    if (path.startsWith('/finance-ic')) {
      return '/tutor/finance-ic-invoices';
    }
    if (path.startsWith('/profit-share')) {
      return isAdmin ? '/admin/tutee-invoices' : '/tutor/lessons';
    }
    // Anything else unknown -> the user's dashboard home.
    return isAdmin ? '/admin' : '/tutor';
  })();

  return <Navigate to={target} replace />;
};

export default LegacyLinkRedirect;
